function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useEffect, useState } from 'react';
import SpinnerApple from "nood-comp/src/comp/ui/spinner/Spinner.Apple";
import FlexCenterCenter from "nood-comp/src/comp/ui/containers/FlexCenterCenter";
import { __get, isHttpOK } from "nood-comp/src/net/xhr";
export var PublicPageContext = /*#__PURE__*/createContext(null);
export default function PublicPage(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    hasPublicAccess = _useState2[0],
    setHasPublicAccess = _useState2[1];
  // get a public token

  useEffect(function () {
    __get('/public.php', {
      base_url: process.env.AUTH
    }, function (res) {
      if (isHttpOK(res)) {
        setHasPublicAccess(true);
      } else setHasPublicAccess(false);
    });
  }, []);
  var __getPublicToken = function __getPublicToken(callback) {
    __get("/public.php", {
      base_url: process.env.AUTH
    }, function (res) {
      if (isHttpOK(res)) {
        callback === null || callback === void 0 || callback();
      }
    });
  };
  if (hasPublicAccess === void 0) {
    return /*#__PURE__*/React.createElement(FlexCenterCenter, null, /*#__PURE__*/React.createElement(SpinnerApple, {
      color: '#000',
      size: 30
    }));
  }
  if (hasPublicAccess === false) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "Unauthorized");
  }
  return /*#__PURE__*/React.createElement(PublicPageContext.Provider, {
    value: {
      __getPublicToken: __getPublicToken
    }
  }, props.children);
}